export default __webpack_public_path__ + "static/media/learn-more.ac3cf85c.jpg";